import { empListData } from 'common/commonRedux/feature/empListSlice';
import { useRustGetDataQuery } from 'common/commonRedux/getRTKApi/rustApi';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useEmpStatus = () => {
  const intAccountId = useSelector(
    (state: any) => state.auth?.profileData?.tokenData?.accountid
  );
   const getEmpListData = useSelector(empListData);
  const getOnlineEmployee = useRustGetDataQuery(
    {
      params: { acc_id: intAccountId },
      urlObjKey: 'GetDashboardOnlineUsers',
    },
    {
      skip: !intAccountId,
    }
  );

  // console.log('Online Employees Data:', getOnlineEmployee);

  const status = useMemo(() => {
    const uniqueEmpsOnline = [...new Set(getOnlineEmployee?.data?.emps)];
    const empList = getEmpListData?.empList || [];

    const activeCount =
      empList.filter((emp: any) => uniqueEmpsOnline.includes(emp.strEmployeeId))
        ?.length || 0;

    const total = empList.length;
    const idleCount = total - activeCount;

    return { activeCount, total, idleCount , uniqueEmpsOnline};
  }, [getOnlineEmployee?.data?.emps, getEmpListData]);

  return {
    ...status,
    isLoading: getOnlineEmployee?.isLoading,
    isFetching: getOnlineEmployee?.isFetching,
    isError: getOnlineEmployee?.isError,
    refetch: getOnlineEmployee?.refetch
  };
};
